/**
* Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
* Created Date: Friday, 19th April 2019
* 
*  Logo Upload & Save Input Field
*/
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject } from 'mobx-react';

// Material UI
import Input from '@material-ui/core/Input';
import CircularProgress from '@material-ui/core/CircularProgress';

// Images
import defaultLogo from 'assets/images/logo_placeholder.jpg';

// Globals
const uploadURL = process.env.REACT_APP_CLOUDINARY_UPLOAD_URL;
const uploadPresetLogo = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET_LOGOS;
// File Size Limit in MB
const maxFileSize = 2;

class LogoInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      response: null,
      imgUrl: '',
      isLoading: false,
    }
    this.handleClick = this.handleClick.bind(this);
    this.handleLogoUpload = this.handleLogoUpload.bind(this);
  }

  handleClick = (e) => {
    const logoInput = document.getElementById('fileLogo');
    logoInput.click();
  }

  handleLogoUpload(e) {
    // Get File from event
    const file = e.target.files[0];
    const fileSizeMB = e.target.files[0].size / 1024 / 1024;

    // Check for Max File Size Limit
    if (fileSizeMB > maxFileSize) {
      //Notify User
      this.props.store.portalStore.snackbar.showSnackbarWithDismiss('Max file size of ' + maxFileSize + 'MB exceeded.', 'error');
      //Exit
      return;
    }

    // Exit if not a valid file.  
    // This can happen when clicking cancel or esc when the dialog is open.
    if (file === undefined) {
      return;
    }

    this.setState({ 
      file: file,
      response: null,
      imgUrl: '',
      isLoading: true
    });

    const url = uploadURL;
    const xhr = new XMLHttpRequest();
    const fd = new FormData();

    // Error Handling
    xhr.onerror = (e) => {
      // If Status = 0, There is an issue connecting to the API server, check the network.
      if (xhr.readyState === 4 && xhr.status === 0) {
        this.props.store.portalStore.snackbar.showSnackbarWithDismiss('Network Error - Please try again.', 'error');
        this.setState({
          isLoading: false,
        })
      }
    }

    xhr.open('POST', url, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    // HttpRequest State Change
    xhr.onreadystatechange = (e) => {
      // Post Completed Successfully
      if (xhr.readyState === 4 && xhr.status === 200) {

        const response = JSON.parse(xhr.responseText);

        // Check for an image url
        if(response.secure_url !== '') {
          this.setState({
            imgUrl: response.secure_url,
            isLoading: false,
          })

          // Check for onChange Props Function, return state
          if(this.props.handleLogoChange && typeof(this.props.handleLogoChange) === 'function') {
            this.props.handleLogoChange(file, response);
          }
        }
      }

      // Check for Error/Bad Request
      if (xhr.readyState === 4 && xhr.status === 400) {
        const response = JSON.parse(xhr.response);
        this.props.store.portalStore.snackbar.showSnackbarWithDismiss(response.error.message, 'error');
        this.setState({
          isLoading: false,
        })
      }
    }

    fd.append('upload_preset', uploadPresetLogo);
    fd.append('tags', 'browser_upload');
    fd.append('tags', 'logo_upload');
    fd.append('api_key', process.env.REACT_APP_CLOUDINARY_API_KEY);
    fd.append('file', file);
    xhr.send(fd);
  }

  render() {
    const { classes, url, handleLogoChange, ...rest } = this.props;
    const { imgUrl, isLoading } = this.state;
    return (
      <div className={classes.wrapper}>
        <div className={classes.logo} >
          <img
            id='logoImg'
            src={url !== '' ? url : (imgUrl === '' ? defaultLogo : imgUrl)}
            className={classes.logoImg}
            alt='Logo'
            onClick={this.handleClick}
          />
          <Input id='fileLogo' type='file' onChange={this.handleLogoUpload}  className={classes.logoInput} {...rest} />
          {isLoading && <CircularProgress size={52} className={classes.logoProgress} />}
        </div>
      </div>
    )
  }
}

LogoInput.propTypes = {
  classes: PropTypes.object.isRequired,
  url: PropTypes.string,
  handleLogoChange: PropTypes.func,
}

const styles = theme => ({
  wrapper: {
    position: 'relative',
    textAlign: 'center',
    width: '210px',
    height: 'auto',
    margin: '5px',
  },
  logo: {
    cursor: 'pointer',
    width: '210px',
    height: 'auto',
    borderRadius: '1%',
    overflow: 'hidden',
  },
  logoImg: {
    width: '100%',
    //height: '100%',
  },
  logoInput: {
    width: '210px',
    //height: '85px',
    cursor: 'pointer',
    display: 'block',
    left: '0',
    opacity: 0 + ' !important',
    position: 'absolute',
    top: 0,
  },
  logoProgress: {
    zIndex: 1,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -25,
    marginLeft: -27,
  },
})

export default withStyles(styles, { withTheme: true })(inject('store')(LogoInput));